import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

type OptionValueType = string | number | boolean | null | string[];

export type TSelectOptionType<TValue extends OptionValueType = OptionValueType,
	TAdditionalProps = Record<string, any>> = null | {
	id?: number | string;
	name?: string;
	label?: string | number;
	title?: string;
	value?: TValue;
	isFixed?: boolean;
	disabled?: boolean;
	tooltipText?: string;
	isDefault?: boolean;
	subText?: string;
	groupLabel?: string;
	groupIndex?: number;
	options?: Array<TSelectOptionType>;
	isPlaceholder?: boolean;
	[key: string]: any;
} & TAdditionalProps;

export const EActionMeta = {
	removeValue: 'remove-value',
	popValue: 'pop-value',
	clear: 'clear',
	selectOption: 'select-option',
	deselectOption: 'deselect-option',
} as const;

export type TActionMeta = TValueOfStringRecord<typeof EActionMeta>
